export class Artworkspecification {
    ID : number;
    Brand : string;
    Crop : string;
    Job : string;
    Language : string;
    Specification : string;
    OpenSize : string;
    FinishSize : string;
    NoPage : string;
    Color : string;
    Fabrication : string;
    PrintingProcess : string;
    Active : boolean;
    Remarks : string;
    unitPriceCurrentQ1:number;
    unitPriceCurrentQ2:number;
    unitPriceCurrentQ3:number;
    unitPriceCurrentQ4:number;
    unitPriceFutureQ1:number;
    unitPriceFutureQ2:number;
    unitPriceFutureQ3:number;
    unitPriceFutureQ4:number;
}

export class DropDown{
    brand : Brand[];
    crop : Crop[];
    language : Language[];
    brandManager : BrandManager[];
    jobType : JobType[];
}

export class Brand{
    brand : string;
}
export class Crop{
    crop : string;
}
export class Language{
    languagae : string;
}
export class BrandManager{
    name : string;
    userID : string;
}
export class JobType{
    job : string;
}